

 <template>
  <section class="purchase-page">
   
     <div class="banner">
    <img :src="bannerUrl" alt="Banner" class="banner" />
     </div>


    <div class="header">
      <button class="back-btn" @click="goBack">
        <span class="material-symbols-outlined">arrow_back_ios</span>
      </button>
      <h2 class="title">Order Summary</h2>
      <div class="progress-dots">
        <span></span>
        <span class="active"></span>
        <span></span>
      </div>
    </div>
    <label class="section-label">Please verify and confirm below order summary</label>

    <div class="form-card">

      <form @submit.prevent="nextStep">
       

        <label>Purchased Mattress Name
          <input v-model="form.productName" readonly />
        </label>

        <label>Mattress Code
          <input v-model="form.mattressCode" readonly />
        </label>

        <label>Product Serial Number<span class="required-star">*</span>
          <input
            v-model="form.productSerialNo"
            @input="validateSerial"
            placeholder="Enter Serial Number"
          />
          <small v-if="errors.serialError" style="color: red">
            {{ errors.serialError }}
          </small>
        </label>


        <label>Mobile Number
          <input v-model="form.customerMobile" readonly />
        </label>

       

        <label>Customer Name<span class="required-star">*</span>
          <input v-model="form.customerName" @input="validateCustomerName" />
          <small v-if="errors.customerName">{{ errors.customerName }}</small>
        </label>

   

        <label>Address 1<span class="required-star">*</span>
          <input v-model="form.address1" @input="validateAddress1" />
          <small v-if="errors.address1">{{ errors.address1 }}</small>
        </label>

        <label>Address 2<span class="required-star">*</span>
          <input v-model="form.address2" @input="validateAddress2" />
          <small v-if="errors.address2">{{ errors.address2 }}</small>
        </label>

        <label>Pin code<span class="required-star">*</span>
          <input v-model="form.pincode" @input="onPinCodeChange" />
          <small v-if="errors.pincode">{{ errors.pincode }}</small>
        </label>

        <label>City
          <input v-model="form.city" readonly placeholder="Auto filled based on Pin code" />
        </label>

        <label>State
          <input v-model="form.state" readonly placeholder="Auto filled based on Pin code" />
        </label>


        <div class="form-card">
        <!-- Edit button on top right -->
        <div class="card-header">
          <h5>Selected Gift</h5>
          
        </div>

        <div class="gift-card">
          <div class="gift-image-wrapper">
            <button class="edit-btn" @click="editGift">
              <i class="fas fa-edit"></i>
            </button>

            <img
              :src="selectedGift.image"
              :alt="selectedGift.name"
              class="gift-image"
            />
          </div>

          <div class="gift-description">
            <p class="gift-name">{{ selectedGift.tmg_description }}</p>
          </div>
        </div>

      </div>
      </form>  

      
          </div>

    

      <div class="validate-wrapper">
          <button class="next-btn" @click="nextStep" :disabled="hasErrors">Submit</button>

          <div v-if="showModal" class="modal-overlay">
            <div class="modal-content">
              <img
                v-if="modalData.code === 0"
                src="@/assets/success-bg.png"
                alt="Success"
                class="modal-image"
              />

              <div class="modal-body">
                  <p v-if="modalData.orderID"><b>Order ID:</b> {{ modalData.orderID }}</p>
                <p class="modal-message">{{ modalData.message }}</p>
                <button class="modal-button" @click="handleClose">
                  {{ modalData.code === 0 ? "Done" : "Close" }}
                </button>
              </div>
            </div>
          </div>
      </div>


      <div class="footer" >
        Powered by Elevatoz PVT LTD
      </div>
  </section>
</template>

<script>
import axios from "axios";
import "@fortawesome/fontawesome-free/css/all.css";

const API_BASE_URL = process.env.VUE_APP_BASE_URL;
const VUE_OTP_BASE_URL = process.env.VUE_APP_OTP_BASE_URL;



export default {
  name: "EditDetails",

  props: {
    customer: { type: Object, required: true },
    selectedGift: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      bannerUrl: process.env.VUE_APP_BANNER_URL,

      form: {
        productName: "",
        mattressCode: "",
        productSerialNo: "",
        customerMobile: "",
        customerName: "",
        address1: "",
        address2: "",
        pincode: "",
        city: "",
        state: ""
        
      },
      errors: {
        customerName: "",
        address1: "",
        address2: "",
        pincode: "",
        serialError: "",

      },
      isOtherSelected: 0,
      showModal: false,
      modalData: null
    };
  },

  created() {
    if (this.customer) {
      this.form = { ...this.customer };
      this.isOtherSelected = this.customer.isOtherSelected;
      // console.log("EditDetails: customer prop received:", this.customer);
      // console.log("Product Name:", this.form.productName);
      // console.log("Mattress Code:", this.form.mattressCode);
      // console.log("Selected Gift:", this.selectedGift);
      // console.log("isOtherSelected calculated on edit page:", this.isOtherSelected);
     }
  },

  computed: {
    hasErrors() {
      return Object.values(this.errors).some(err => err);
    }
  },

  methods: {
    goBack() {
      this.$emit("go-back");
    },
    closeModal() {
      this.showModal = false;
      this.modalData = null;
    },
    handleClose() {
      this.showModal = false;
      // Redirect to first page
      this.$emit("go-back-to-first-page");
    },

    editGift() {
      // console.log("Edit gift clicked", this.selectedGift.tmg_description);
      this.$emit("go-back");
    },

    nextStep() {
      this.validateCustomerName();
      this.validateAddress1();
      this.validateAddress2();
      this.validatePincode();
      this.validateSerial();

      if (!this.hasErrors) {
        this.submitForm(); 
      }
    },


async validateSerial() {
  this.form.productSerialNo = this.form.productSerialNo.replace(/[^a-zA-Z0-9]/g, "");


  if (this.form.productSerialNo.length !== 8) {
    this.errors.serialError = "Serial number must be exactly 8 alphanumeric characters.";
    return;
  }
  const productCode = this.form.mattressCode;   // declared here
  if (!productCode) {
    this.errors.serialError = "Product code is missing. Please go back and select the product.";
    return false;
  }

  try {
    const res = await axios.post(`${API_BASE_URL}vt/centuryCenflex/checkserialno`, {
      serialNo: this.form.productSerialNo,
      product_code: productCode
    }, {
      headers: { "Content-Type": "application/json" }
    });

    if (res.data.code === 0) {
      this.errors.serialError = "";
    } else if (res.data.errors?.serialNo) {
      this.errors.serialError = res.data.errors.serialNo; 
    } else {
      this.errors.serialError = res.data.message || "Serial number invalid.";
    }

  } catch (err) {
    // console.error("Serial check failed:", err);
    this.errors.serialError = err.response?.data?.errors?.serialNo
      || err.response?.data?.message
      || "Duplicate claim detected. This serial number has already been used.";
  }
},
 
    validateCustomerName() {
      const val = this.form.customerName.trim();
      if (!val) this.errors.customerName = "Required";
      else if (!/^[a-zA-Z ]+$/.test(val)) this.errors.customerName = "Only letters allowed";
      else if (val.length < 2) this.errors.customerName = "Min 2 characters";
      else this.errors.customerName = "";
    },

    validateAddress1() {
      const val = this.form.address1.trim();
      if (!val) this.errors.address1 = "Required";
      else if (val.length < 3) this.errors.address1 = "Min 3 characters";
      else this.errors.address1 = "";
    },

    validateAddress2() {
      const val = this.form.address2.trim();
      if (!val) this.errors.address2 = "Required";
      else if (val.length < 3) this.errors.address2 = "Min 3 characters";
      else this.errors.address2 = "";
    },

    validatePincode() {
      const regex = /^[1-9][0-9]{5}$/;
      if (!this.form.pincode) this.errors.pincode = "Required";
      else if (!regex.test(this.form.pincode)) this.errors.pincode = "Invalid pin code";
      else this.errors.pincode = "";
    },

    onPinCodeChange() {
      this.validatePincode();
      this.fillCityState();
    },

    async fillCityState() {
      const pin = this.form.pincode.trim();
      try {
        const response = await axios.post(
             "https://loyalty.elevatozrewards.com/wp-json/el/v1/lookup/pincode",
          { pincode: pin },
          {
            headers: {
              "api-key": "a9298379-58ab-11ef-a68b-b646c323312d",
              "Content-Type": "application/json"
            }
          }
        );

        const data = response.data?.response?.data?.[0];
        if (data) {
          this.form.city = data.pincodeCity;
          this.form.state = data.pincodeState;
        } else {
          this.form.city = "";
          this.form.state = "";
        }
      } catch (error) {
        // console.error("Pincode API error:", error);
        this.form.city = "";
        this.form.state = "";
      }
    },

  
      async submitForm() {
         const payload = {
      
        customerName: this.form.customerName,
        customerEmail: this.customer.customerEmail,
        address1: this.form.address1,
        address2: this.form.address2,
        pincode: this.form.pincode,
        city: this.form.city,
        state: this.form.state,
        productName: this.form.productName,
        productCode: this.form.mattressCode,
        productSerialNo: this.form.productSerialNo,
        quantity: Number(this.customer.quantity || 1),
        customerMobile: this.form.customerMobile,
        // gift1: this.selectedGift?.tmg_gift_code || null
        gift1: this.selectedGift?.tmg_id || null,
        is_other : this.isOtherSelected,


      };
      
      try {
        const res = await axios.post(
          `${API_BASE_URL}vt/centuryCenflex/micrositesubmission`,
          payload
        );

        this.modalData = res.data;
        this.showModal = true;

        if (res.data.code === 0) {
          const CorderID = res.data.data?.orderID;
          this.modalData = { code: 0, message: res.data.message ,     orderID: CorderID  };
          this.showModal = true;
          this.$emit("submission-success", res.data);

          const oc_payload = {
            mobile: this.form.customerMobile,
            orderID: res.data.data?.orderID,
            productName: res.data.data?.productName,
          };


          try {
            const smsRes = await axios.post(
           `${VUE_OTP_BASE_URL}wp-json/el/v1/auth/micrositeOrderConfirmSMS`, 
              oc_payload
            );
            console.log("SMS API Response:", smsRes.data);
          } catch (smsErr) {
            console.error("SMS API failed:", smsErr);
          }
        } else {
          this.modalData = res.data;
          this.showModal = true;
          this.$emit("submission-error", res.data);
        }
      } catch (err) {
        this.modalData = {
          code: -1,
          message: err.response?.data?.message || "API call failed!",
        };
        this.showModal = true;
      }

    },
    
  }
};

</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4); 
  display: flex;
  justify-content: center;
  align-items: center; 
  z-index: 999;
  padding: 15px;
  box-sizing: border-box;
}

.modal-content {
  width: 360px;
  max-width: 100%;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.modal-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.modal-body {
  padding: 20px;
  text-align: center;
}

.modal-message {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  margin-bottom: 20px;
}

.modal-button {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  color: #fff;
  background-color: #00688B;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.modal-button:hover {
  background-color: #005575;
}




.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.edit-btn {
  padding: 5px 10px;
  background-color: #006488;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
}

.edit-btn:hover {
  background-color: #005575;
}

.gift-card {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  gap: 10px;
  align-items: center;
}

.gift-image-wrapper img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.gift-description {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.gift-name {
  font-weight: 500;
  font-size: 14px;
}

.gift-price {
  font-size: 13px;
  color: #555;
  margin-top: 5px;
}





.purchase-page {
  font-family: 'Poppins', sans-serif;
  padding: 15px;
  max-width: 400px;
  margin: 0 auto;
}

.banner img {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 15px;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.back-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.title {
  font-weight: 500;
  font-size: 1.3rem;
  flex: 1;
  text-align: left;
}

.progress-dots {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
  width: 100%;
}

.progress-dots span {
  width: 10px;
  height: 10px;
  background: #ccc;
  border-radius: 50%;
  display: inline-block;
}

.progress-dots span.active {
  background: #006488;
}

.form-card {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

form label {
  display: block;
  margin-bottom: 12px;
  font-size: 14px;
}

input {
  width: 100%;
  padding: 8px 10px;
  margin-top: 4px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

small {
  color: red;
  font-size: 12px;
}

.validate-wrapper {
  display: flex;             
  flex-direction: column; 
  align-items: center;     
  gap: 20px;               
  margin-top: 20px;      
}

.next-btn {
  width: 40%;             
  padding: 12px;
  background: #00688B;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}


.next-btn:disabled {
  background: #005575;
  cursor: not-allowed;
}

.next-btn:hover:enabled {
  background: #005575;
}
.required-star {
    color: red;
  }

.otp-footer {
  display: flex;
  justify-content: center;
}
.footer {
  margin-top: auto; 
  font-size: 0.6rem;
  color: #888;
  text-align: center;
}
.note-text {
  font-family: 'Inter'f;
  font-weight: 600; 
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  color:  #D00000;

  margin-top: 5px;
  text-align: center;
}
@media (max-width: 480px) {
  .purchase-page {
    padding: 10px;
  }
}
</style>